import React from "react";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { IEventHotel, IEventSummary } from "@eagerdog/interfaces";

import { helperService } from "src/services/helper.service";
import Icon from "src/components/Icon/Icon";
import Button from "src/components/Button/Button";

import styles from "./HotelsTab.module.scss";

interface IProps {
  hotel: IEventHotel;
  event: IEventSummary;
  isAdmin: boolean;
  onEdit(hotel: IEventHotel): void;
  onDelete(hotel: IEventHotel): void;
}

const HotelTile: React.FC<IProps> = (props) => {
  const { hotel } = props;

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: props.event.currency?.toUpperCase() || "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return (
    <div className={styles.HotelTile}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <div className={styles.titleRow}>
            <span className={styles.title}>{hotel.name}</span>
            {hotel.distance_value !== undefined && (
              <div className={styles.distancePill}>
                <Icon className={styles.locationIcon} type="location" />
                <span>{hotel.distance_value} {hotel.distance_unit} away</span>
              </div>
            )}
            {hotel.has_special_rate && <div className={styles.badge}>Special Rate</div>}
          </div>
          <div className={styles.address}>{helperService.formatAddress(hotel.address)}</div>
          {hotel.phone && (
            <div className={styles.phoneRow}>
              <Icon className={styles.phoneIcon} type="phone" />
              <a className={styles.phone} href={`tel:${hotel.phone}`}>
                {formatPhoneNumberIntl(hotel.phone) || hotel.phone}
              </a>
            </div>
          )}
        </div>
        <div className={styles.right}>
          {hotel.has_special_rate && hotel.rate !== undefined && hotel.rate !== null && (
            <div className={styles.rate}>{formatter.format(hotel.rate)} / night</div>
          )}
          {props.isAdmin && (
            <div className={styles.actions}>
              <ul>
                <li onClick={() => props.onEdit(hotel)}><Icon className={styles.icon} type="edit" /></li>
                <li onClick={() => props.onDelete(hotel)}><Icon className={styles.icon} type="delete" /></li>
              </ul>
            </div>
          )}
          {hotel.website_url && (
            <Button className={styles.bookBtn} onClick={() => window.open(helperService.normalizeUrl(hotel.website_url), "_blank", "noreferrer")}>Book</Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default HotelTile;
